"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _OneSideCommonComponentModule = _interopRequireDefault(require("./OneSideCommonComponent.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function OneSideCommonComponent(props) {
  var updateActiveSelected = function updateActiveSelected(value) {
    props.sendDataToParent(true);
    // setTimeout(() => props.sendDataToParent(false), 10);
  };
  var isChildNotNullish = function isChildNotNullish(child) {
    if (!!child) {
      var childProps = child.props;
      var numberKeys = Object.keys(childProps).length;
      if (numberKeys > 0) {
        return true;
      }
      return false;
    }
    return false;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _OneSideCommonComponentModule["default"].wholeWrapper,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
        className: _OneSideCommonComponentModule["default"].title,
        children: props.title
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _OneSideCommonComponentModule["default"].centralWrapper,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "".concat(_OneSideCommonComponentModule["default"].inputWrapper),
          children: [isChildNotNullish(props.children[0]) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: _OneSideCommonComponentModule["default"].selectorsWrapper,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _OneSideCommonComponentModule["default"].selectors,
              children: props.children[0]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
              variant: "outlined",
              color: "primary",
              component: "span" // So that the InputLabel is styled like a button
              ,
              className: _OneSideCommonComponentModule["default"].buttonConvert,
              onClick: function onClick() {
                return updateActiveSelected();
              },
              children: "Check result"
            })]
          }), props.children[1]]
        }), props.children[2]]
      })]
    })
  });
}
var _default = exports["default"] = OneSideCommonComponent;